<template>
	<svg
		width="51px"
		height="34px"
		viewBox="0 0 51 34"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="camera on icon"
	>
		<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
			<g
				transform="translate(-627.000000, -472.000000)"
				:fill="color"
				fill-rule="nonzero"
			>
				<g transform="translate(532.000000, 242.000000)">
					<g transform="translate(64.000000, 207.000000)">
						<path
							d="M59.6113281,56.9121094 C63.8007812,56.9121094 66.2714844,54.5058594 66.2714844,50.359375 L66.2714844,30.2714844 C66.2714844,26.125 63.9941406,23.7402344 59.8046875,23.7402344 L37.9550781,23.7402344 C33.9375,23.7402344 31.2949219,26.125 31.2949219,30.2929688 L31.2949219,50.4023438 C31.2949219,54.5488281 33.765625,56.9121094 37.9550781,56.9121094 L59.6113281,56.9121094 Z M78.7109375,53.8183594 C80.3007812,53.8183594 81.375,52.6582031 81.375,50.9609375 L81.375,29.7128906 C81.375,28.015625 80.3007812,26.8554688 78.7109375,26.8554688 C77.9160156,26.8554688 77.0996094,27.2636719 76.3476562,27.9082031 L69.1074219,34.1601562 L69.1074219,46.5136719 L76.3476562,52.765625 C77.0996094,53.4101562 77.9375,53.8183594 78.7109375,53.8183594 Z"
							id="camera-on"
						></path>
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'CameraOn',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
	},
}
</script>
